import { useTranslation } from "react-i18next";

type Props = {
  value: string;
  onChange: (next: string) => void;
};

export function TagSearchBox({ value, onChange }: Props) {
  const { t } = useTranslation();
  return (
    <label className="reveal reveal-delay-1 relative block">
      <span className="sr-only">{t("chargers.tag_search")}</span>
      <svg
        aria-hidden="true"
        viewBox="0 0 20 20"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        className="pointer-events-none absolute left-4 top-1/2 h-4 w-4 -translate-y-1/2 text-fg-faint"
      >
        <circle cx="9" cy="9" r="6" />
        <path d="m17 17-3.5-3.5" />
      </svg>
      <input
        type="search"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={t("chargers.tag_search_placeholder")}
        aria-label={t("chargers.tag_search")}
        className="w-full rounded-full border border-line bg-surface py-3 pl-12 pr-4 text-sm text-fg shadow-sm transition-colors placeholder:text-fg-faint focus:border-volt focus:outline-none focus:ring-2 focus:ring-volt/30"
      />
    </label>
  );
}
